import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../services/api';

export interface Batch {
  id: string;
  name: string;
  species_name?: string;
  strain_name?: string;
  variety_name?: string; // Sometimes used interchangeably
  stage: string;
  plant_count: number;
  start_date: string;
  status: 'active' | 'archived' | 'planned';
}

interface UseBatchesOptions {
  status?: 'active' | 'archived' | 'planned';
}

export const useBatches = (options: UseBatchesOptions = {}) => {
  const [batches, setBatches] = useState<Batch[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchBatches = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params: any = {};
      if (options.status) params.status = options.status;

      const response = await apiClient.get<any>('/batches', { params });
      // Backend handles wrapping differently across modules, normalize here
      const data = response?.data || response;
      setBatches(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch batches');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [options.status]);

  useEffect(() => {
    fetchBatches();
  }, [fetchBatches]);

  return {
    batches,
    loading,
    error,
    refetch: fetchBatches,
  };
};
